export const canUpdateMember = (params) => {
    const { memberInformation, loggedInMemberId, isValidMemberInformation, selectedDepartmentId, selectedMembershipId, } = params;
    return Boolean(memberInformation &&
        loggedInMemberId &&
        isValidMemberInformation &&
        selectedDepartmentId &&
        selectedMembershipId);
};
